var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 12C7.91721 12 7.83574 11.9794 7.76294 11.94L1.26294 8.44001L1.73704 7.56001L7.99999 10.9322L14.2629 7.56001L14.737 8.44036L8.23704 11.9404C8.1642 11.9796 8.08273 12.0001 7.99999 12Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 15C7.91721 15 7.83574 14.9794 7.76294 14.94L1.26294 11.44L1.73704 10.56L7.99999 13.9322L14.2629 10.56L14.737 11.4404L8.23704 14.9404C8.1642 14.9796 8.08273 15.0001 7.99999 15Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 9.00001C7.91721 9 7.83574 8.97938 7.76294 8.94001L1.26294 5.44001C1.18347 5.39719 1.11708 5.33367 1.07081 5.25617C1.02453 5.17867 1.0001 5.09009 1.0001 4.99983C1.0001 4.90957 1.02453 4.82099 1.07081 4.74349C1.11708 4.666 1.18347 4.60247 1.26294 4.55966L7.76294 1.05966C7.83577 1.02035 7.91723 0.99977 7.99999 0.99977C8.08275 0.99977 8.16421 1.02035 8.23704 1.05966L14.737 4.55966C14.8165 4.60247 14.8829 4.666 14.9292 4.74349C14.9754 4.82099 14.9999 4.90957 14.9999 4.99983C14.9999 5.09009 14.9754 5.17867 14.9292 5.25617C14.8829 5.33367 14.8165 5.39719 14.737 5.44001L8.23704 8.94001C8.16423 8.97938 8.08276 9 7.99999 9.00001ZM2.55469 5.00001L7.99999 7.93216L13.4453 5.00001L7.99999 2.06791L2.55469 5.00001Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/Layers.652c11b2894c180c537abf9dde5354a0.svg";
export { ForwardRef as ReactComponent };